import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, firstValueFrom, of } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { AuthApi } from 'src/app/shared/apis/auth.api';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CSInputComponent } from 'src/app/shared/components/cs-input/cs-input.component';
import { CSTabComponent } from 'src/app/shared/components/cs-tab/cs-tab.component';
import { Ganeral2faVerifyModule } from 'src/app/shared/components/general2faverify/general2faverify.module';
import { ThirdAuthM8Component } from 'src/app/shared/components/third-auth-m8/third-auth-m8.component';
import { ThirdAuthM8Service } from 'src/app/shared/components/third-auth-m8/third-auth-m8.service';
import { TimeoutCountdownDialogComponent } from 'src/app/shared/components/timeout-countdown-dialog/timeout-countdown-dialog.component';
import { LoginByEmailParams, Need2Fa, ThirdAuthUser, VerifyAction } from 'src/app/shared/interfaces/auth.interface';
import { ResponseData } from 'src/app/shared/interfaces/response.interface';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatConnectedDialog } from 'src/app/shared/service/connected-dialog';
import { DataCollectionService } from 'src/app/shared/service/data-collection.service';
import { EncryptService } from 'src/app/shared/service/encrypt.service';
import { GeetestService } from 'src/app/shared/service/geetest.service';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { ValidatorService } from 'src/app/shared/service/validator.service';
import { HelpCenterService } from '../../help-center/help-center.service';
import { LoginService } from '../login.service';

@UntilDestroy()
@Component({
  standalone: true,
  selector: 'login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.scss'],
  imports: [
    CSInputComponent,
    CSTabComponent,
    CSButtonComponent,
    CSIconButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    Ganeral2faVerifyModule,
    PipesModule,
    ThirdAuthM8Component,
  ],
})
export class LoginRegisterComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<LoginRegisterComponent>,
    private geetestService: GeetestService,
    private encryptService: EncryptService,
    private authApi: AuthApi,
    private dataCollectionService: DataCollectionService,
    private appService: AppService,
    public matConnectedDialog: MatConnectedDialog,
    public loginService: LoginService,
    private toast: ToastService,
    private thirdAuthM8Service: ThirdAuthM8Service,
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private helpCenterService: HelpCenterService,
  ) {}

  @HostListener('document:keydown.enter', ['$event'])
  public onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !this.submitDisabled) {
      if (this.type === 'login') {
        this.handleLogin();
      } else {
        this.handleSignUp();
      }
    }
  }

  @Input()
  set tabIndex(value: number) {
    this._tabIndex = value;
    this.type = value === 0 ? 'signup' : 'login';
    if (this._tabIndex === 0) {
      this.formRegister.controls['email'].setValue('');
      this.formRegister.controls['password'].setValue('');
      this.isRegisterDirty = false;
    } else {
      this.formLogin.controls['email'].setValue('');
      this.formLogin.controls['password'].setValue('');
      this.isLoginDirty = false;
    }
  }

  private _tabIndex = 0;

  get tabIndex() {
    return this._tabIndex;
  }

  get emailHasError() {
    return this.type === 'login'
      ? this.formLogin.controls['email'].invalid
      : this.formRegister.controls['email'].invalid;
  }

  get registerPwdErrors() {
    return this.formRegister.controls['password'].errors || {};
  }

  public tabs: string[] = ['Sign Up', 'Log In'];

  public type: 'signup' | 'login' = 'signup';

  /** 用户绑定的ID */
  public socialUserId!: string;

  /** 用户用户绑定 */
  public socialUserType!: ThirdAuthUser;

  // 登入和注册的组件
  public passwordType: 'password' | 'text' = 'password';

  /** 下次是否自动登录 */
  public isAutoLogin: boolean = true;

  public uniCode: string = '';

  /** 用户2FA数据 */
  public user2fa!: Need2Fa;

  public referee: string = ''; //推荐人

  /** aff 参数 用户通过别的链接来到注册页面 带过来的参数 */
  public myAff: string = '';

  public otpType: VerifyAction = 'Register';

  public isLoginDirty: boolean = false;

  public isRegisterDirty: boolean = false;

  public loading: boolean = false;

  public serverErrorText: string = '';

  public formLogin: FormGroup = new FormGroup({
    email: new FormControl('', { validators: [ValidatorService.emailValidator()] }),
    password: new FormControl(''),
  });

  public formRegister: FormGroup = new FormGroup({
    email: new FormControl('', { validators: [ValidatorService.emailValidator()] }),
    password: new FormControl('', { validators: [ValidatorService.passwordStrengthValidator()] }),
  });

  public ngOnInit() {
    // 用户从注册页面过来， 因为已经注册过且绑定
    if (this.thirdAuthM8Service.userLogin) {
      this.thirdAuthM8Service.afterVerify$.next(this.thirdAuthM8Service.verifyData);
      this.thirdAuthM8Service.userLogin = false;
    }

    this.formLogin.controls['password'].valueChanges.subscribe(() => {
      if (this.type === 'login') {
        this.isLoginDirty = true;
        this.serverErrorText = '';
      }
    });
    this.formRegister.controls['password'].valueChanges.subscribe(() => {
      if (this.type === 'signup') {
        this.isRegisterDirty = true;
      }
    });
    combineLatest([
      of(this.localStorageService.inviteCode),
      of(this.localStorageService.myAffiliate),
      this.activatedRoute.queryParams,
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([localeInviteCode, localeAffiliate, params]) => {
        const inviteCode = params?.inviteCode || localeInviteCode || '';
        const aff = params?.aff || localeAffiliate || '';
        if (inviteCode && inviteCode.length > 0) {
          this.referee = inviteCode as string;
          this.localStorageService.inviteCode = inviteCode;
        }
        if (aff && aff.length > 0) {
          this.localStorageService.myAffiliate = aff;
          this.myAff = this.localStorageService.myAffiliate ?? '';
        }
      });
  }

  onTabChanged(e: number) {
    this.tabIndex = e;
    this.type = e === 0 ? 'signup' : 'login';
  }

  close() {
    this.dialogRef.close();
  }

  /**
   * 登录操作
   */
  async handleLogin() {
    if (this.formLogin.invalid) {
      this.formLogin.markAllAsTouched();
      return;
    }

    this.loading = true;
    const result = await firstValueFrom(await this.geetestService.verify());
    if (result) {
      //加密密码
      const password = this.formLogin.get('password')?.value;
      const encryptedPassWord = this.encryptService.encrypt(password);
      await this.handleEmailLogin(result, encryptedPassWord);
    }
    this.loading = false;
  }

  /**
   * 邮箱登录
   *
   * @param result  验证结果
   * @param encryptedPassWord 加密密码
   */
  async handleEmailLogin(result: any, encryptedPassWord: string) {
    const param: LoginByEmailParams = {
      lotNumber: result.lot_number,
      captchaOutput: result.captcha_output,
      passToken: result.pass_token,
      genTime: result.gen_time,
      email: this.formLogin.get('email')?.value,
      password: encryptedPassWord,
      autoLogin: this.isAutoLogin,
    };
    const responseData = await firstValueFrom(this.authApi.loginByEmail(param));
    if (responseData?.success) {
      const data = responseData?.data;
      this.uniCode = data?.uniCode;
      if (data?.need2Fa) {
        this.user2fa = {
          tFaGoogle: data?.tFaGoogle,
          tFaMobile: data?.tFaMobile,
          tFaEmail: data?.tFaEmail,
          mobile: data?.mobile,
          areaCode: data?.areaCode,
          email: this.formLogin.get('email')?.value,
          hidePhoneNum: data?.mobile,
          hideEmailNum: data?.email,
        };

        this.loginService.handleLogin2fa({
          need2fa: this.user2fa,
          email: this.formLogin.get('email')?.value,
          uniCode: this.uniCode,
        });
      } else {
        this.dataCollectionService.gtmPush('login', { login_type: 'login' });
        this.appService.logged(data?.token);
      }
    } else {
      this.handleErrorMessage(responseData);
    }
  }

  /**
   * 处理登录Api返回的错误信息
   *
   * @param responseData
   */
  private handleErrorMessage(responseData: ResponseData<any> | null) {
    //帐户密码错误 x 次
    if (responseData?.code == '2010' || responseData?.code == '2011' || responseData?.code == '2113') {
      const match = responseData?.message.match(/(\d+)\s*$/);
      const num = match ? match[1] : '0';

      this.serverErrorText = `The email and password entered did not match our records. You have ${num} remaining attempts.`;
      return;
    }

    if (responseData?.code == '2112') {
      // 帐户已注冊
      this.toast.show({
        message: 'The account has been registered',
        type: 'fail',
      });
    }

    // 1004 用户已經登入
    if (responseData?.code === '1004') {
      setTimeout(() => {
        this.appService.reFresh();
      }, 1000);
    }
    // 2124 用户处于 Responsible Gaming timeout 状态
    if (responseData?.code === '2124') {
      const { endUnixTimestamp, period, reopenKey, reopenUnixTimestamp, startUnixTimestamp } =
        responseData?.data?.memberTimeout || {};
      this.close();
      this.matConnectedDialog.open(TimeoutCountdownDialogComponent, {
        data: {
          startUnixTimestamp,
          endUnixTimestamp,
          reopenUnixTimestamp,
          period,
          reopenKey,
        },
        disableClose: true,
      });
      return;
    }

    // code 2013 禁止登入
    if (responseData?.code === '2013') {
      this.helpCenterService.showUnableLoginPopup();
      return;
    }

    this.toast.show({
      message: responseData?.message ?? 'Incorrect username or password',
      type: 'fail',
    });
  }

  public onPasswordClick() {
    if (this.passwordType === 'password') {
      this.passwordType = 'text';
    } else {
      this.passwordType = 'password';
    }
  }

  public onForgotClick() {
    this.loginService.handleForgotPassword();
  }

  /**
   * 注册操作
   */
  async handleSignUp() {
    if (this.loading) return;
    if (this.formRegister.invalid) {
      this.formRegister.markAllAsTouched();
      return;
    }

    this.loading = true;
    try {
      const email = this.formRegister.get('email')?.value;
      const verifyRes = await firstValueFrom(
        this.authApi.verifyEmailBeforeOtp({
          email,
          otpType: 'Register' as VerifyAction,
        }),
      );

      if (!verifyRes?.success) {
        this.toast.show({
          message: verifyRes?.message || 'This email is already registered. Please sign in instead.',
          type: 'fail',
        });
        return;
      }

      const result = await firstValueFrom(await this.geetestService.verify());
      //滑动验证成功
      if (result) {
        //加密密码
        const password = this.formRegister.get('password')?.value;
        const encryptedPassWord = this.encryptService.encrypt(password);
        await this.handleEmailSignUp(result, encryptedPassWord);
      }
    } catch (error) {
      console.error('handleSignUp verifyEmailBeforeOtp error', error);
    } finally {
      this.loading = false;
    }
  }

  async handleEmailSignUp(result: any, encryptedPassWord: string) {
    this.user2fa = {
      email: this.formRegister.get('email')?.value,
    };
    this.loginService.handleRegister2fa({
      need2fa: this.user2fa,
      email: this.formRegister.get('email')?.value,
      uniCode: result.geetest_challenge,
      referee: this.referee,
      myAff: this.myAff,
      password: encryptedPassWord,
    });
  }

  clickAuthName(authName: ThirdAuthUser) {
    switch (authName) {
      case ThirdAuthUser.WalletConnect:
      case ThirdAuthUser.TonConnect:
        this.close();
        break;

      default:
        this.loginService.handleThirdPartyNotLogin(authName);
        break;
    }
  }
  get submitDisabled(): boolean {
    return this.type === 'login'
      ? (this.formLogin.invalid && this.isLoginDirty) ||
          this.formLogin.controls['email'].value === '' ||
          this.formLogin.controls['password'].value === ''
      : (this.formRegister.invalid && this.isRegisterDirty) ||
          this.formRegister.controls['email'].value === '' ||
          this.formRegister.controls['password'].value === '';
  }
}
